<support-desk-ticket *ngIf="ready" [tenantId]="tenantId" [ticketId]="ticketId" [ticketService]="ticketService"
    [accessToken]="accessToken" [backlink]="null" additionalContainerClass="my-8"></support-desk-ticket>